import React, {useState} from "react";
import "./index.scss";
import * as Actions from "../../../../redux/actions";
import * as Popups from "../../../../constants/popup-types";
import {useDispatch, useSelector} from "react-redux";
import {getMediaPath} from "../../../../app/functions";


const ConsultExpert = (props) =>{
    const dispatch = useDispatch();
    const text = useSelector(state => state.config.Translations);
    const deviceState = useSelector(state => state.state.deviceState);
    const vehicleAdsPage = useSelector(state => state.data.VehicleAdsPage);

    const handleAskExpert = () =>{
        dispatch(Actions.addPopup({
            type: Popups.CAR_LEAD_FORM_POPUP,
            screenHeight : window.innerHeight,
            data: vehicleAdsPage.expert,
            isExpert:true,
            titleBold: text["car_lead_expert_popup_title"],
        }));
    }

    function setBGImage(){
        if(deviceState === "mobile"){
            return getMediaPath(vehicleAdsPage.expert.mobileImagePath);
        }
        return getMediaPath(vehicleAdsPage.expert.imagePath);
    }

    return (
    <div className='consult-expert'>
        <div className="top-banner">
            <div className='right-side'>
                <span className="bold-header-text">{vehicleAdsPage.expert.bold_header_text}</span>
                <span className="sub-header-text">{vehicleAdsPage.expert.sub_header_text}</span>
                {deviceState !== "mobile" &&
                    <div className="bottom-banner">
                        <button className="button" onClick={handleAskExpert}>{vehicleAdsPage.expert.btn_text}</button>
                    </div>
                }

            </div>
            <div className='left-side'>
                <img className="expert-img" src={setBGImage()} alt=""/>
                <div className="text-wrapper">
                    <span className="expert-title">{vehicleAdsPage.expert.title}</span>
                    <span className="expert-sub-title">{vehicleAdsPage.expert.sub_title}</span>
                </div>
            </div>
        </div>
        { deviceState === "mobile" &&
            <div className="bottom-banner">
                <button className="button" onClick={handleAskExpert}>{vehicleAdsPage.expert.btn_text}</button>
            </div>
        }

    </div>

    );
}

export default ConsultExpert
